<template>
    <div class="file-container">  
        <slot></slot>
        <input multiple type="file" @change="upload($event.target.files)" />
    </div>
</template>

<script>

import Utilities from '../helpers/Utilities';
import DataHelpers from '../helpers/DataHelpers';
import AlertHelpers from '../helpers/AlertHelpers';
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

export default {
    data() {
        return {
        
        }
    },
    
    props: {
        path: String,
        returnObject: {
            type: Object,
            default: () => {key:null}
        },
    },

    computed: {
        test() {
            return null
        }
    },

    methods: {
        upload(files) {

            Utilities.log('uploading...', files)
            
            if(!this.path) {
                this.$emit('error', 'Path not provided')
            }
            let uploadList = Array.from(files).map(file => {
                return {
                    file: file,
                    key: DataHelpers.getKey(),
                    name: file.name,
                    loading: true,
                    url: null,
                }
            })

            const counterTarget = uploadList.length
            let counterComplete = 0

            this.broadcastChange(counterComplete, counterTarget, uploadList)
            this.$emit('startAll', this.returnObject)

            uploadList.forEach(upload => {

                let file = upload.file
                let copy = this.copyOfUpload(upload)
                
                this.$emit('start', copy)

                if(file.size > 7500000) {
                    upload.status = 'Failed'
                    counterComplete += 1
    
                    AlertHelpers.showAlert(file.name + ' is too big (' + parseInt(file.size / 1000000) + 'mb). Max 7mb' )
                    upload.loading = false  
                    this.$emit('finish', this.copyOfUpload(upload), this.returnObject) 
                    if(counterComplete == counterTarget) {

                        const filesUploaded = uploadList.map(o => o.name).join(', ')
                        let obj = {
                            returnObject: this.returnObject,
                            files: filesUploaded
                        }
                        //this.$emit('finishAll', obj)              
                    }
                } else {

                    const fileReader = new FileReader
                    fileReader.addEventListener('load', () => {
                        let result = fileReader.result
                        let filePath = this.path + '/' + file.name
                        upload.status = 'Loading'
                        Utilities.log('Started uploading')
                        
                        Firebase.storage().ref(filePath).put(file)
                        .then(fileData => {

                            fileData.ref.getDownloadURL().then(url => {
                                Utilities.log('Finished uploading')
    
                                upload.loading = false
                                upload.url = url
                                counterComplete += 1
                                //this.broadcastChange(counterComplete, counterTarget, uploadList)
                                this.$emit('finish', this.copyOfUpload(upload), this.returnObject)
                                if(counterComplete == counterTarget) {
                                    const filesUploaded = uploadList.map(o => o.name).join(', ')
                                    let obj = {
                                        returnObject: this.returnObject,
                                        files: filesUploaded
                                    }
                                    this.$emit('finishAll', obj)
                                }
                            })
                            
                        })
                    })

                    fileReader.readAsDataURL(upload.file) 
                }

            })

        },

        copyOfUpload(upload) {
            let copy = Object.assign({}, upload)
            delete copy['file']
            return copy
        },

        broadcastChange(completeCount, targetCount, uploads) {
            let message, complete
            if(completeCount == targetCount) {
                message = 'Upload complete'
                complete = true
            } else {
                message = `Uploading ${completeCount + 1} of ${targetCount}`
                complete = false
            }
            let result =  {
                message,
                complete,
                uploads,
            }
            this.$emit('change', result)
        }

    }
}
</script>

<style scoped>
.file-container {
    overflow: hidden;
    position: relative;
}
.file-container [type=file] {
    cursor: inherit;
    display: block;
    font-size: 999px;
    filter: alpha(opacity=0);
    min-height: 100%;
    min-width: 100%;
    opacity: 0;
    position: absolute;
    right: 0;
    text-align: right;
    top: 0;
    cursor: pointer;
}   
</style>




// WEBPACK FOOTER //
// UploadFirebase.vue?3d2ff40a